import { useCallback, useMemo, useState } from 'react'

import { Button } from 'core-components/library/button'
import { Menu } from 'core-components/library/menu'
import { ModalDialog } from 'core-components/library/modalDialog'
import { IFlexItem } from 'core-components/sitebuilder/models/flexGrid/IFlexItem'
import {
  FlexWrapperSettingsContent,
  IFlexWrapperSettingsContent,
} from 'core-components/sitebuilder/settings/wrapper/flexWrapperHeaderSettings/FlexWrapperSettingsContent'
import { BaseCrud, Static } from 'core-components/types'

import styles from './WrapperActionsSelector.module.scss'

interface IWrapperActionsSelector {
  item: IFlexItem
  updateItem: (newItem: IFlexItem) => void
}

export const WrapperActionsSelector = (props: IWrapperActionsSelector) => {
  const { item, updateItem } = props
  const [settingsVisible, setSettingsVisible] = useState<boolean>(false)

  const wrapperMenuCrud = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static([
        {
          id: 'stretchVert',
          label: 'Stretch items vertically',
        },
        {
          id: 'alignToTop',
          label: 'Align items Top',
        },
        {
          id: 'wrapBreakpoints',
          label: 'Set Flex Wrap breakpoints',
        },
      ]),
      keyField: 'id',
    })
  }, [])

  const changeItemsAlignment = useCallback((items: IFlexItem[], alignValue: boolean) => {
    return items.reduce((acc: IFlexItem[], item) => {
      const newWidgetSettings = item.widgets.map((widget) => {
        return { ...widget, alignContentTop: alignValue }
      })
      return [...acc, { ...item, widgets: newWidgetSettings }]
    }, [])
  }, [])

  const performMenuFunction = useCallback(
    (id: string) => {
      switch (id) {
        case 'stretchVert':
          if (item.layoutSet) {
            const newItem = {
              ...item,
              layoutSet: {
                items: changeItemsAlignment(item.layoutSet.items, false),
              },
            }
            updateItem(newItem)
          }
          break
        case 'alignToTop':
          if (item.layoutSet) {
            const newItem = {
              ...item,
              layoutSet: {
                items: changeItemsAlignment(item.layoutSet.items, true),
              },
            }
            updateItem(newItem)
          }
          break
        case 'wrapBreakpoints':
          setSettingsVisible(true)
          break
      }
    },
    [changeItemsAlignment, item, updateItem]
  )

  return (
    <>
      <Menu
        classes={{
          root: styles.dotsMenu,
        }}
        subMenuClasses={{
          row: styles.dotsMenu__row,
          cell: styles.dotsMenu__cell,
          iconCell: styles.dotsMenu__iconCell,
        }}
        content={() => (
          <Button variant={'text'} color={'grey'} iconButton={'kbase kbase-menu-dots'} />
        )}
        source={wrapperMenuCrud}
        caption={'label'}
        onChoose={performMenuFunction}
      />
      <ModalDialog<IFlexWrapperSettingsContent>
        size={'auto'}
        content={FlexWrapperSettingsContent}
        contentProps={props}
        title={'Flex Wrap settings'}
        show={settingsVisible}
        onClose={() => setSettingsVisible(false)}
      />
    </>
  )
}
